import React from 'react';

/**
 * Compact dark hero used by every inner page. Keeps the first fold consistent
 * so visitors (and 10DLC vetters) always know which company they are on.
 */
export default function PageHero({ eyebrow, title, lede, image, children, compact = false }) {
  return (
    <section className="relative isolate overflow-hidden bg-navy-900 text-white">
      {image && (
        <img
          src={image}
          alt=""
          aria-hidden="true"
          className="absolute inset-0 -z-20 h-full w-full object-cover opacity-30"
        />
      )}
      <div className="texture-dark absolute inset-0 -z-10" aria-hidden="true" />
      <div
        className="absolute inset-0 -z-10 bg-gradient-to-b from-navy-900/70 via-navy-900/60 to-navy-900"
        aria-hidden="true"
      />
      <div className={`shell ${compact ? 'pb-12 pt-32 sm:pb-16 sm:pt-36' : 'pb-16 pt-36 sm:pb-24 sm:pt-44'}`}>
        <div className="max-w-3xl">
          {eyebrow && <div className="eyebrow mb-4 animate-fadeUp text-gold-300">{eyebrow}</div>}
          <h1 className="h1 animate-fadeUp text-white" style={{ animationDelay: '0.08s' }}>
            {title}
          </h1>
          {lede && (
            <p className="lede mt-5 animate-fadeUp max-w-2xl text-navy-100" style={{ animationDelay: '0.18s' }}>
              {lede}
            </p>
          )}
          {children && (
            <div className="mt-8 animate-fadeUp" style={{ animationDelay: '0.26s' }}>
              {children}
            </div>
          )}
        </div>
      </div>
      <div className="diagonal-stripe h-2 w-full" aria-hidden="true" />
    </section>
  );
}
